import React, { useState } from "react";

import PanelTemplate from "../../templates/Panel";
import BoxTabs from "../../components/BoxTabs";

import PaymentTermsTab from "./tabs/terms";
import PaymentMethodsTab from "./tabs/methods";

// Cadastro de condições e formas de pagamento (BDM-1208). Não é do módulo
// financeiro: o orçamento escolhe a condição em qualquer plano.
export const PaymentConditions = () => {
    const [tab, setTab] = useState(0);

    return (
        <PanelTemplate id="payment-conditions">
            <BoxTabs
                tab={tab}
                setTab={setTab}
                titles={['Condições de pagamento', 'Formas de pagamento']}
                contents={[
                    <PaymentTermsTab />,
                    <PaymentMethodsTab />,
                ]}
            />
        </PanelTemplate>
    );
};

export default PaymentConditions;
